module.exports = __webpack_public_path__ + "static/woonkameraam-5c79a9c577d6c7e834d174ef07dd7984.jpg";